export class PDDatos {
    nombre: string;
    valor: string;
    campo: string;

}
